// extracted by mini-css-extract-plugin
export var acitonButtons = "_cv-0";
export var additionalIcon = "_cv-f";
export var block = "_cv-1";
export var blockContent = "_cv-7";
export var blockDescription = "_cv-8";
export var blockIcon = "_cv-9";
export var blockTitle = "_cv-6";
export var border = "_cv-a";
export var center = "_cv-l";
export var edge = "_cv-b";
export var edgeLabel = "_cv-c";
export var edgePath = "_cv-d";
export var error = "_cv-e";
export var flowchart = "_cv-g";
export var flowchartContent = "_cv-h";
export var highlighted = "_cv-3";
export var hover = "_cv-4";
export var icon = "_cv-i";
export var left = "_cv-m";
export var navButton = "_cv-j";
export var navButtons = "_cv-k";
export var right = "_cv-n";
export var selected = "_cv-2";
export var small = "_cv-5";